import * as constants from "./constants";

export const setLabDetailsIsEdit = (data) => {
  return {
    type: constants.LAB_DETAILS_IS_EDIT,
    data: data,
  };
};

export const createLab = (data) => {
  return {
    type: constants.CREATE_LAB,
    data: data,
  };
};

export const createLabSuccess = (data) => {
  return {
    type: constants.CREATE_LAB_SUCCESS,
    data: data,
  };
};

export const createLabError = () => {
  return {
    type: constants.CREATE_LAB_ERROR,
  };
};

export const fetchLab = (data) => {
  return {
    type: constants.FETCH_LAB,
    data: data,
  };
};

export const fetchLabSuccess = (data) => {
  return {
    type: constants.FETCH_LAB_SUCCESS,
    data,
  };
};

export const fetchLabError = () => {
  return {
    type: constants.FETCH_LAB_ERROR,
  };
};

export const updateLab = (data) => {
  return {
    type: constants.UPDATE_LAB,
    data: data,
  };
};

export const updateLabSuccess = (data) => {
  return {
    type: constants.UPDATE_LAB_SUCCESS,
    data: data,
  };
};

export const updateLabError = () => {
  return {
    type: constants.UPDATE_LAB_ERROR,
  };
};

export const fetchLabDetailsUtils = () => {
  return {
    type: constants.FETCH_LABS_UTIL_DATA,
  };
};

export const fetchLabDetailsUtilsSuccess = (data) => {
  return {
    type: constants.FETCH_LABS_UTIL_DATA_SUCCESS,
    data,
  };
};

export const fetchAllLabs = (data) => {
  return {
    type: constants.FETCH_ALL_LABS,
    data,
  };
};

export const fetchAllLabsSuccess = (data) => {
  return {
    type: constants.FETCH_ALL_LABS_SUCCESS,
    data,
  };
};
export const fetchAllLabsError = (data) => {
  return {
    type: constants.FETCH_ALL_LABS_ERROR,
    data,
  };
};
export const deleteLab = (data) => {
  return {
    type: constants.DELETE_LAB,
    data,
  };
};

export const deleteLabSuccess = (data) => {
  return {
    type: constants.DELETE_LAB_SUCCESS,
    data,
  };
};

export const deleteLabError = (data) => {
  return {
    type: constants.DELETE_LAB_ERROR,
    data,
  };
};

export const deleteLabAttach = (data) => {
  return {
    type: constants.DELETE_LAB_ATTACH,
    data,
  };
};

export const deleteLabAttachSuccess = (data) => {
  return {
    type: constants.DELETE_LAB_ATTACH_SUCCESS,
    data,
  };
};

export const deleteLabAttachError = (data) => {
  return {
    type: constants.DELETE_LAB_ATTACH_ERROR,
    data,
  };
};

export const labDetailCleanupFunc = () => {
  return {
    type: constants.LAB_DETAIL_CLEANUP_FUNC,
  };
};

export const setLabNotificationIsEdit = (data) => {
  return {
    type: constants.LAB_NOTIF_IS_EDIT,
    data: data,
  };
};

export const updateLabNotifications = (data) => {
  return {
    type: constants.UPDATE_LAB_NOTIFICATION,
    data: data,
  };
};

export const updateLabNotificationsSuccess = (data) => {
  return {
    type: constants.UPDATE_LAB_NOTIFICATION_SUCCESS,
    data: data,
  };
};

export const updateLabNotificationsError = () => {
  return {
    type: constants.UPDATE_LAB_NOTIFICATION_ERROR,
  };
};

export const deleteStockNotificationRecipient = (data) => {
  return {
    type: constants.DELETE_STOCK_NOTIFICATION_RECIPIENT,
    data: data,
  };
};

export const deleteStockNotificationRecipientSuccess = (data) => {
  return {
    type: constants.DELETE_STOCK_NOTIFICATION_RECIPIENT_SUCCESS,
    data: data,
  };
};

export const deleteStockNotificationRecipientError = (error) => {
  return {
    type: constants.DELETE_STOCK_NOTIFICATION_RECIPIENT_ERROR,
    error: error,
  };
};

export const fetchLabUsers = (data) => {
  return {
    type: constants.FETCH_LAB_USERS,
    data,
  };
};

export const fetchLabUsersSuccess = (data) => {
  return {
    type: constants.FETCH_LAB_USERS_SUCCESS,
    data,
  };
};


export const fetchLabUsersError = () => {
  return {
    type: constants.FETCH_LAB_USERS_ERROR,
  };
};

export const fetchLabUsersMap = (data) => {
  return {
    type: constants.FETCH_LAB_USERS_MAP,
    data,
  };
};

export const fetchLabUsersMapSuccess = (data) => {
  return {
    type: constants.FETCH_LAB_USERS_MAP_SUCCESS,
    data,
  };
};

export const fetchLabUsersMapError = () => {
  return {
    type: constants.FETCH_LAB_USERS_MAP_ERROR,
  };
};

export const fetchWarehouses = () => {
  return {
    type: constants.FETCH_WAREHOUSES,
  };
};

export const fetchWarehousesSuccess = (data) => {
  return {
    type: constants.FETCH_WAREHOUSES_SUCCESS,
    data,
  };
};

export const fetchWarehousesError = () => {
  return {
    type: constants.FETCH_WAREHOUSES_ERROR,
  };
};
